import { React, useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import { startingAzuleLogin, logoutUser, logoutClearStore } from "../../actions/userActions"
import { clearMultibase } from "../../actions/multiAiBase"
import Tooltip from "@material-ui/core/Tooltip"
import { useMsal } from "@azure/msal-react"
import { loginRequest } from "../../config/authConfig"
import { clearLocalStorage, LOCAL_STORAGE_KEYS } from "../../utils"

const SideLogoutButton = ({ link }) => {
	const { instance } = useMsal()
	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	/* ******************* END REDUX STORE ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const userLogout = (e) => {
		e.preventDefault()
		dispatch(logoutClearStore())
		dispatch(logoutUser())
		clearLocalStorage()
		dispatch(clearMultibase())
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	const handleLogout = () => {
		dispatch(logoutClearStore())
		dispatch(logoutUser())
		instance.logoutRedirect(loginRequest)
		dispatch(startingAzuleLogin(false))
		localStorage.removeItem(LOCAL_STORAGE_KEYS.SELECTED_PROJECT)
	}

	return (
		<div className="list-group-item not-underlined text-dark border-0 pb-3" style={{ marginTop: "50px" }}>
			<hr />
			<div className="w-100 d-flex py-2 px-3 justify-content-center">
				{window._env_.REACT_APP_AUTH_TYPE === "SELF" ? (
					<Link to={link} className="list-group-item not-underlined text-dark border-0 left-menu-item" onClick={userLogout}>
						<Tooltip title="Logout" placement="top" arrow>
							<button data-cy="logout_button" className="btn btn-outline-primary btnLogout">
								<i className="bi bi-box-arrow-left" style={{ fontSize: "30px" }}></i>
							</button>
						</Tooltip>
					</Link>
				) : null}

				{window._env_.REACT_APP_AUTH_TYPE === "MSOFT" ? (
					<Link to={link} className="list-group-item not-underlined text-dark border-0 left-menu-item" onClick={handleLogout}>
						<Tooltip title="Logout" placement="top" arrow>
							<button className="btn btn-outline-primary btnLogout">
								<i className="bi bi-box-arrow-left" style={{ fontSize: "30px" }}></i>
							</button>
						</Tooltip>
					</Link>
				) : null}
			</div>
		</div>
	)
}

export default SideLogoutButton
